<template>
  <div class="innerBox">
    <div class="row">
      <div class="col-md-6" :class="mobile ? 'order-1 mb-3' : 'order-2 text-right'">
        <button type="button" class="btn btn-sm btn-primary" @click="$router.push('/inventory/sparepart-estimations')">< Kembali</button>
      </div>
      <div class="col-md-6" :class="mobile ? 'order-2' : 'order-1'">
        <h2 class="mb-4">Detil Work Order</h2>
      </div>
    </div>


    <div class="row">
      <div class="col-md-4 align-middle" :class="{'mb-4' : mobile}">
        <img :src="env.baseImage + '/' +  woDetail.image" class="w-100" v-if="woDetail.image">
        <h4 v-else class="text-center">No Image Available</h4>
      </div>
      <div class="col-md-8">
        <div class="row">
          <div class="col-md-6">
            <table class="wo-stats">
              <tr>
                <th>Work Order ID:</th>
                <td>{{ woDetail.show_wo }}</td>
              </tr>
              <tr>
                <th>No Mesin:</th>
                <td>{{ woDetail.nomor_mesin }}</td>
              </tr>
              <tr>
                <th>No Rangka:</th>
                <td>{{ woDetail.nomor_rangka }}</td>
              </tr>
              <tr>
                <th>No Polisi:</th>
                <td>{{ woDetail.nomor_polisi }}</td>
              </tr>
              <!-- <tr>
                <th>Asuransi:</th>
                <td>{{ woDetail.asuransi }}</td>
              </tr> -->
              <!-- <tr>
                <th>Kerusakan:</th>
                <td>{{ woDetail.kerusakan }}</td>
              </tr> -->
              <tr>
                <th>Tahun Mobil:</th>
                <td>{{ woDetail.year }}</td>
              </tr>
            </table>
          </div>
          <div class="col-md-6">
            <table class="wo-stats">
              <tr>
                <th>Tanggal Masuk:</th>
                <td>{{ woDetail.tanggal_masuk }}</td>
              </tr>
              <tr>
                <th>Pelanggan:</th>
                <td>{{ woDetail.pelanggan }}</td>
              </tr>
              <tr>
                <th>CSO:</th>
                <td>{{ woDetail.cso }}</td>
              </tr>
              <tr>
                <th>Merek:</th>
                <td>{{ woDetail.merek }}</td>
              </tr>
              <tr>
                <th>Tipe:</th>
                <td>{{ woDetail.tipe }}</td>
              </tr>
              
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mt-3">
            <button v-if="woFull.serviceType != 'Beli Sparepart'" type="button" class="btn btn-outline-primary w-100" @click="$router.push({ name : 'EstimatorApplication' , params : {id : woDetail.work_order_id}})">Ke Estimator</button>
            <button v-else type="button" class="btn btn-outline-primary w-100" @click="$router.push({ name : 'EstimatorParts' , params : {id : woDetail.work_order_id}})">Ke Estimator</button>
          </div>
          <!-- <div class="col-md mt-3">
            <button type="button" class="btn btn-outline-info w-100" @click="printWO">Print</button>
          </div> -->
          <div class="col-md-6 mt-3">
            <button type="button" class="btn btn-outline-warning w-100" @click="modal.showOverallImage = true">Lihat Gambar</button>
          </div>
          <div class="col-12 mt-3">
            <button type="button" class="btn btn-outline-secondary w-100" @click="downloadPdf">Download PDF</button>
          </div>
        </div>
      </div>
    </div>

    <hr style="margin:20px">
    <!-- {{historyChange}} -->
    <!-- Estimasi Suku Cadang start -->
    <div class="row">
      <div class="col-md-6">
        <h2 class="mb-4">Parts Quotation</h2>
      </div>
      <div class="col-md-6 text-right">
        <!-- <button class="btn btn-sm btn-primary" @click="modal.add = true" :disabled="sparepartEstimations.length == 0">Parts Quotation Baru</button> -->
        <button class="btn btn-sm btn-secondary mr-3" @click="modal.showHistory = true" >Price Change History</button>
        <!-- <button class="btn btn-sm" :class="{'btn-primary' : !edit , 'btn-success' : edit}" @click="edit = !edit">{{edit ? 'Finish' : 'Edit'}} Parts Quotation</button> -->
        
      </div>
    </div>

    <div v-if="edit">
      <!-- <label>Supplier</label> -->
      <MultiSelect
        class="mt-3 mb-3"
        v-model="universal.supplier_id"
        :options="options.supplier.map(x => x.id)"
        :custom-label="opt => options.supplier.find(x => x.id == opt).name"
        :searchable="true"
        :close-on-select="true"
        :multiple="false"
        :allow-empty="false"
        placeholder="Pilih Supplier"
      ></MultiSelect>
    </div>

    <div class="row" v-if="sparepartEstimations && sparepartEstimations.length == 0">
      <div class="col text-center pt-5 pb-5">
        <p style="font-size:16px; color:grey;">
          Tambah Sparepart Di Halaman
          <router-link :to="'/estimator/estimator-application/' + woDetail.work_order_id">Estimator</router-link>
          Terlebih Dahulu
        </p>
      </div>
    </div>
    
    <div class="row" v-else style="font-size:12px;max-height:600px;overflow-y:scroll">
      <div class="col">
        <table class="estimation-sparepart-table table">
          <thead>
            <tr>
              <th>No.</th>
              <th>Sparepart</th>
              <th>Part Description</th>
              <th>Qty</th>
              <th>Supplier</th>
              
              <th>Inden</th>
              <th>Diskon Supplier (%)</th>
              <th>Pricelist Supplier</th>
              <th>Harga / Item</th>
              <th>Total</th>
              <th>Tanggal Input</th>
              <th colspan="2"><i class="fas fa-cog"></i></th>
            </tr>
          </thead>
          <tbody v-for="(data, index) in sparepartEstimations.filter(x => !x.is_supplied_by_insurance)">
            <tr :class="{'bg-green' : data.supplier_prices.length > 0 &&  data.selected_price == data.supplier_prices[0].id}">
              <td :rowspan="data.supplier_prices.length > 0 ? !edit ? data.supplier_prices.length : data.supplier_prices.length + 1 : '2'"
                :class="{'bg-green' : data.selected_price}">
                {{index + 1}}.
              </td>
              <td
                :rowspan="data.supplier_prices.length > 0 ? !edit ? data.supplier_prices.length : data.supplier_prices.length + 1 : '2'"
                :class="{'bg-green' : data.selected_price}"
              >{{ data.sparepart_name }}</td>
              <td :rowspan="data.supplier_prices.length > 1 ? !edit ? data.supplier_prices.length : data.supplier_prices.length + 1 : '2'"
                :class="{'bg-green' : data.selected_price}"
                >{{data.part_number}}</td>
              <td
                :rowspan="data.supplier_prices.length > 1 ? !edit ? data.supplier_prices.length : data.supplier_prices.length + 1 : '2'"
                :class="{'bg-green' : data.selected_price}"
              >{{ data.quantity }}</td>
             
                <td>{{ data.supplier_prices.length > 0 ? data.supplier_prices[0].supplier_name : '-' }}</td>
                
                <td>{{ data.supplier_prices.length > 0 ? data.supplier_prices[0].inden + ' Hari' : '-' }}</td>
                <td>{{ data.supplier_prices.length > 0 ? data.supplier_prices[0].supplier_discount : '-' }}</td>
                <td>{{ data.supplier_prices.length > 0 ? data.supplier_prices[0].supplier_pricelist : '-' }}</td>
                <td>{{ data.supplier_prices.length > 0 ? 'Rp. ' + numberWithCommas(data.supplier_prices[0].price_per_item) : '-' }}</td>
                <td>{{ data.supplier_prices.length > 0 ? 'Rp. ' + numberWithCommas((parseFloat(data.supplier_prices[0].price_per_item)) * data.quantity) : '-' }}</td>
                <td>{{ data.supplier_prices.length > 0 ? moment(data.supplier_prices[0].created_at).format('MMM DD,Y')  : '-'}}</td>
                
                <td colspan="2">
                  <button
                    v-if="data.supplier_prices.length > 0 && edit"
                    class="btn btn-outline-danger mr-2"
                    @click="removeEstimationConfirmation(data.supplier_prices[0].id)"
                  >
                    <i class="fas fa-times text-red"></i>
                  </button>
                  <button class="btn btn-outline-primary ml-2 mt-1" @click="setPurchaseItem(data.estimations_id , data.supplier_prices[0].id)">
                    Pilih
                  </button>
                </td>
            </tr>
            <tr v-if="data.supplier_prices.length > 1" v-for="estimation in data.supplier_prices.slice(1)" :class="{'bg-green' : data.selected_price == estimation.id}">
              <td>{{ estimation.supplier_name }}</td>
              
              <td>{{ estimation.inden + ' Hari'}}</td>
              <td>{{ estimation.supplier_discount }}</td>
              <td>{{estimation.supplier_pricelist}}</td>
              <td>Rp. {{ numberWithCommas(estimation.price_per_item) }}</td>
              <td>Rp. {{ numberWithCommas(parseFloat(estimation.price_per_item) * data.quantity) }}</td>
              <td>{{ moment(estimation.created_at).format('MMM DD,Y')}}</td>
              <td colspan="2">
                <button class="btn btn-outline-danger mr-2" @click="removeEstimationConfirmation(estimation.id)" v-if="edit">
                  <i class="fas fa-times text-red"></i>
                </button>
                <button class="btn btn-outline-primary ml-2 mt-1"  @click="setPurchaseItem(data.estimations_id , estimation.id)">
                  Pilih
                </button>
              </td>
            </tr>
            <template v-if="edit" >
              <!-- data.estimations_id -->
              <tr></tr>
              <tr style="background-color:#EEE">
                <!-- <td colspan="3" style="min-width:350px">
                  <label>Supplier</label>
                  <MultiSelect
                    
                    v-model="formList[data.estimations_id].supplier_id"
                    :options="options.supplier.map(x => x.id)"
                    :custom-label="opt => options.supplier.find(x => x.id == opt).name"
                    :searchable="true"
                    :close-on-select="true"
                    :multiple="false"
                    :allow-empty="false"
                    placeholder="Pilih Supplier"
                  ></MultiSelect>
                </td> -->
                <td colspan="2">
                  <label>Waktu Inden</label>
                  <input class="form-control" type="text" name="name" v-model="formList[data.estimations_id].inden" placeholder="Inden">
                </td>
                <td colspan="2">
                  <label>Diskon Supplier ( 1-100 )</label>
                  <input class="form-control" type="number" name="name" v-model="formList[data.estimations_id].supplier_discount" placeholder="Diskon">
                </td>
                <td colspan="2">
                  <label>Pricelist Supplier</label>
                  <input class="form-control" type="text" name="name" v-model="formList[data.estimations_id].supplier_pricelist" placeholder="Pricelist Supplier">
                </td>
                <td colspan="2">
                  <label>Harga / Item</label>
                  <input disabled class="form-control" type="text" name="name" v-model="formList[data.estimations_id].price_per_item" placeholder="Harga Satuan">
                </td>
                <td colspan="3">
                  <label>Total</label>
                  <input disabled class="form-control" type="text" name="name" v-model="formList[data.estimations_id].total">
                  
                </td>
                <td>
                  <label></label>
                  <button class="btn btn-outline-success" @click="submitForm(formList[data.estimations_id])" v-if="edit">
                    <i class="fas fa-check text-success"></i>
                  </button>
                    
                </td>
              </tr>
            </template>
            <tr v-if="edit">
              <td colspan="20">
                <div
										class=" row"
                >
                <div class="offset-0 offset-md-6 col-md-2 form-check form-check-inline">
                  <input
                    :disabled="formList[data.estimations_id].without_ppn"
                    class="form-check-input"
                    style="width:15%"
                    type="checkbox"
                    id="inlineCheckbox1"
                    value="option1"
                    v-model="formList[data.estimations_id].inclusivePPN"
                  />
                  
                  <label
                    class="form-check-label"
                    for="inlineCheckbox1"
                    style="min-width:100px"
                    >Harga Termasuk PPN</label
                  >
                </div>
                <div class="col-md-2 form-check form-check-inline">
                  <input
                    :disabled="formList[data.estimations_id].without_ppn"
                    class="form-check-input"
                    style="width:15%"
                    type="checkbox"
                    id="inlineCheckbox1"
                    value="option1"
                    v-model="formList[data.estimations_id].exclusivePPN"
                  />
                  
                  <label
                    class="form-check-label"
                    for="inlineCheckbox1"
                    style="min-width:100px"
                    >Harga Diluar PPN</label
                  >
                </div>
                <div class="col-md-2 form-check form-check-inline">
                  <!-- <input
                    class="form-check-input"
                    type="checkbox"
                    style="width:15%"
                    id="inlineCheckbox1"
                    value="option1"
                    v-model="formList[data.estimations_id].without_ppn"
                  /> -->
                  <input
                    class="form-check-input"
                    type="checkbox"
                    style="width:15%"
                    id="inlineCheckbox1"
                    value="option1"
                    v-model="formList[data.estimations_id].without_ppn"
                  />
                  <label
                    class="form-check-label"
                    for="inlineCheckbox1"
                    
                    >Harga Tanpa PPN</label
                  >
                </div>
                
                  
                  <!-- <br> -->
                  
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Estimasi Suku Cadang end -->

    <!-- Modals Start -->
    <new-estimation-supplier
      v-if="modal.add"
      :available_estimations="availableEstimations"
      :form_code="form_code"
      @closeModal="modal.add = false"
      @updateTable="getSparepartEstimations"
    ></new-estimation-supplier>

    <preview-image
      v-if="modal.showOverallImage"
      @closeModal="modal.showOverallImage = false"
      :title="'Gambar WO ' + woDetail.work_order_id"
      :image="imagesList"
    ></preview-image>

    <!-- <print-work-order
      v-if="modal.printWO"
      @closeModal="modal.printWO = false"
      :data="woFull"
    ></print-work-order> -->
    <!-- Modals End -->

    <pdfEstimation 
      v-if="modal.showPDF"
      @closeModal="modal.showPDF = false"
      :woDetail="woDetail"
      :sparepartEstimations="sparepartEstimations"
    />

    <historyModal 
      v-if="modal.showHistory"
      @closeModal="modal.showHistory = false"
      :historyList="historyChange"
      :sparepartEstimations="sparepartEstimations"
    />

    <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        :filename="'Parts Quotation ' + woDetail.work_order_id"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-content-width="100%"
        pdf-format="a4"
        pdf-orientation="landscape"
 

        @hasStartedGeneration="hasStartedGeneration()"
        @hasGenerated="hasGenerated($event)"
        ref="html2Pdf"
    >
        <section slot="pdf-content">
           <pdfEstimation 
              :woDetail="woDetail"
              :sparepartEstimations="sparepartEstimations"
           />
        </section>
    </vue-html2pdf>

    

  </div>
</template>

<script>
  import moment from 'moment'
  import VueHtml2pdf from 'vue-html2pdf'

  import newEstimationSupplier from './children/newEstimationSupplier'
  import pdfEstimation from './children/pdfEstimation'
  import historyModal from './children/historyModal.vue'

  // import printWorkOrder from './children/printWorkOrder'
  import Multiselect from 'vue-multiselect'

  import previewImage from '@/components/modal/previewImage'
  import env from '@/env'

  export default {
    data () {
      return {
        edit : true,
        universal : {
          supplier_id : null
        },
        env,
        moment,
        mobile : this.isMobile(),
        modal : {
          add : false,

          printWO : false,

          showOverallImage : false,
          showHistory : false,
        },
        sparepartEstimations : [],
        currentSelectedUploadImage : null,
        titleUpload : '',
        form_code : this.$route.params.id,
        options : {
          woSteps : this.$store.getters.getWoSteps,
          supplier : null
        },
        formModel : {
          estimations_id : '',
          supplier_id : '',
          price_per_item : '',
          inden : '',
          ppn_included : false,
          markup : 0,
          supplier_discount : 0,
          supplier_pricelist : '',
          without_ppn  : false,
          total : 0,
          inclusivePPN : false,
          exclusivePPN : false,
          // hargaWithPPN : false
        },
        formList : {},
        woFull : null,
        woDetail : {
          work_order_id : '-',
          nomor_mesin : '-',
          nomor_rangka : '-',
          nomor_polisi : '-',
          asuransi : '-',
          kerusakan : '-',
          tanggal_masuk : '-',
          pelanggan : '-',
          cso : '-',
          merek : '-',
          tipe : '-',
        },
        woProgress : [],
        figureGrouping : {
          front : ['front_bumper', 'front_left_light', 'front_right_light', 'front_windshield', 'grill', 'left_fog_light', 'right_fog_light'],
          rear : ['rear_bumper', 'rear_left_light', 'rear_right_light', 'rear_windshield'],
          left : ['front_left_door', 'front_left_fender', 'front_left_wheel', 'rear_left_door', 'rear_left_fender', 'rear_left_wheel'],
          right : ['front_right_door', 'front_right_fender', 'front_right_wheel', 'rear_right_door', 'rear_right_fender', 'rear_right_wheel'],
          atap : ['roof', 'sunroof']
        },
        imagesList : [],
        stepImage : '',
        watcherList : [],
        historyChange : null
      }
    },
    watch : {
      edit : function () {
        let vm = this
        // if(this.edit) {
          
        // }
      }
    },
    components : {
      newEstimationSupplier,
      pdfEstimation,
      VueHtml2pdf,
      Multiselect,
      historyModal,
      // printWorkOrder,

      previewImage,
    },
    mounted () {
      // this.getWoListingSteps();
      this.getSparepartEstimations();
      this.getWoDetails();
      this.getHistory();
      this.loadSupplierList()
      // this.getSuppliers();

      
      // this.getWoProgress();
      // this.generateData()
    },
    computed : {
      availableEstimations(){
        //limits 3
        // return this.sparepartEstimations.filter(x=>x.supplier_prices.length<3).map((x)=>{return{id:x.estimations_id, name:x.sparepart_name}});

        return this.sparepartEstimations.map((x)=>{return{id:x.estimations_id, name:x.sparepart_name, part_description : x.part_number}});
      },
    },
    methods : {
      loadSupplierList () {
        this.$http.get('/api/v1/masterData/supplier?pagination=false')
        .then((resp) => {
          this.options.supplier = resp.data.data
        })
        .catch((err) => {
          console.log(err)
        })
      },
      countTotal(estimation_id , amount) {
        let curForm = this.formList[estimation_id]
        if(!curForm.supplier_pricelist){
          this.formList[estimation_id].price_per_item = 0;
        }
        else {
          let price_per_item = parseFloat(curForm.supplier_pricelist.split(',').join('')) * (100 - parseInt(curForm.supplier_discount)) / 100
          let total = parseInt(parseFloat(price_per_item) * parseFloat(amount))
          this.formList[estimation_id].total = this.numberWithCommas(total)
          // this.formList[estimation_id].price_per_item = price_per_item
          this.$set(this.formList[estimation_id] , 'price_per_item' , this.numberWithCommas(price_per_item))
        }
      },
      downloadPdf () {
        this.$refs.html2Pdf.generatePdf()
      },
      printWO(){
        this.modal.printWO = true
      },
      setPurchaseItem (estimation_id ,supplier_price_id ) {
        // console.log(estimation_id , supplier_price_id)
        // return
        let obj = {
          supplier_price_id: parseInt(supplier_price_id)
        };


        this.$http
				.patch("/api/v1/estimations/" + estimation_id, obj)
				.then((resp) => {
					// this.$store.dispatch('triggerAlert', [true, [`Sparepart Berhasil Ditambah`]]);
					this.getSparepartEstimations();
          this.getHistory();
				})
				.catch((err) => {
					console.log(err);
				});
      },
      removeEstimationConfirmation(id){
        this.$swal.fire({
          title: 'Apakah anda yakin?',
          text: "Estimasi supplier pada suku cadang ini akan dihapus!",
          type: 'warning',
          showCancelButton: true
        }).then((result) => {
          if (result.value) {
            this.$http.delete(`/api/v1/estimations-supplier/${id}`)
            .then((resp)=>{
              this.getSparepartEstimations();
              this.getHistory();
              this.$swal.fire(
                'Berhasil!',
                'Estimasi supplier telah berhasil dihapus',
                'success'
              )
            })
            .catch((err)=>{console.log(err)})
          }
        })
      },
      getWoDetails(){
        this.$http.get(`/api/v1/workorder/${this.form_code}/detail`)
        .then(async (resp)=>{
          var data = resp.data.data;
          let carDetail = data.customer_car ? this.$store.getters.getModelDetailById(data.customer_car.car_id) : null

          this.woDetail = {
            work_order_id : this.form_code,
            show_wo : data.serviceType + ' - ' + this.form_code,
            nomor_mesin : data.customer_car ? data.customer_car.engine_number : data.engine_number ? data.engine_number : '-',
            nomor_rangka : data.customer_car ? data.customer_car.chassis_number : data.chassis_number ? data.chassis_number : '-',
            nomor_polisi : data.customer_car ? data.customer_car.registration : data.registration ? data.registration : '-',
            asuransi : '-',
            kerusakan : data.condition ? this.evaluateDamage(data.condition.figure) : '-',
            tanggal_masuk : moment(data.created_at).format('DD MMM YY HH:mm'),
            pelanggan : data.customer ? data.customer.name : '-',
            cso : data.CSO,
            year: data.customer_car ? data.customer_car.year : data.year ? data.year : '-',
            merek : data.customer_car ? carDetail.brand_name : data.brand ? data.brand.name : '-',
            tipe : data.customer_car ? carDetail.name : data.model ? data.model.name : '-',
            image : data.condition ? data.condition.figureOverall.front.image : '-'
          }

          this.woFull = data;
          this.imagesList = data.condition ? await this.parseImages(data.condition.figureOverall, data.condition.figure) : []
        })
        .catch((err)=>{console.log(err)})
      },
      evaluateDamage(figure){
        var damages = ""
        for(var i in figure){
          for(var j in figure[i]){
            if(figure[i][j]) damages += `${this.toCapitalizedWords(j)}, `
          }
        }

        return damages ? damages.substring(0, damages.length-2) : '-'
      },
      parseImages(figureOverall, figure){
        var images = []
        var figureGrouping = this.figureGrouping;

        var englishIndoDictionary = {
          front : 'depan',
          rear : 'belakang',
          left : 'kiri',
          right : 'kanan',
          atap : 'atap'
        }

        for(var i in figureGrouping){
          //Figure Overall
          if (figureOverall[i]) {
            if (typeof figureOverall[i] == 'string') images.push({
              image:figureOverall[i],
              description:`Bagian tampak '${i}'.`
            })
            else if (typeof figureOverall[i] == 'object') {
              for (var j in figureOverall[i].image) images.push({
                image:figureOverall[i].image[j],
                description:`Bagian tampak ${englishIndoDictionary[i]}. Deskripsi : '${figureOverall[i].desc}'. ${(figureOverall[i].image.length > 1) ? ' Gambar ' + (parseInt(j)+1) + ' dari ' + figureOverall[i].image.length + '.' : ''}`
              })
            }
          }

          //Damages / Kerusakan
          for (var j in figure[i]){//Single Part (kacaDepan, atapMobil, etc.)
            if(figure[i][j]){
              for (var k in figure[i][j].image) images.push({
                image:figure[i][j].image[k],
                description:`Bagian ${englishIndoDictionary[i]}. Kerusakan '${this.toCapitalizedWords(j)}'. Deskripsi : '${figure[i][j].desc}'. ${(figure[i][j].image.length > 1) ? ' Gambar ' + (parseInt(j)+1) + ' dari ' + figure[i][j].image.length + '.' : ''}`
              })
            }
          }
        }

        return images;
      },
      getSparepartEstimations(){
        this.$http.get(`/api/v1/estimations-supplier/${this.form_code}`)
        .then((resp)=>{
          this.$set(this , 'sparepartEstimations' , resp.data.data.filter((data)=>{
            // return !data.is_approved_by_insurance && !data.is_supplied_by_insurance && data.sparepart_type == "P"
            return data.sparepart_type == "P"
          }));
        })
        .then(()=> {
          for(var i = 0 ; i < this.sparepartEstimations.length ; i++) {
            let formModel = JSON.parse(JSON.stringify(this.formModel))
            let estimation_id = this.sparepartEstimations[i].estimations_id
            let amount = this.sparepartEstimations[i].quantity
            // console.log(this.sparepartEstimations[i])
            this.$set(this.formList , this.sparepartEstimations[i].estimations_id , formModel)
            if(!this.watcherList.includes(this.sparepartEstimations[i].estimations_id)) {
              this.watcherList.push(this.sparepartEstimations[i].estimations_id)

              this.$watch(`formList.${this.sparepartEstimations[i].estimations_id}.supplier_discount` , function(newVal , oldVal) {
                // const result = newVal.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                newVal = parseInt(newVal)
                if(newVal > 100) {
                  this.$store.dispatch('triggerAlert' , [false , 'Discount tidak boleh melewati 100%'])
                  newVal = 0
                }
                this.countTotal(estimation_id , amount)
                this.$nextTick(() => this.formList[estimation_id].supplier_discount = newVal);
              })

              this.$watch(`formList.${this.sparepartEstimations[i].estimations_id}.supplier_pricelist` , function(newVal , oldVal) {
                this.countTotal(estimation_id , amount)
                const result = newVal.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                this.$nextTick(() => this.formList[estimation_id].supplier_pricelist = result);
              })  
            }
            
            this.formList[this.sparepartEstimations[i].estimations_id].estimations_id = this.sparepartEstimations[i].estimations_id
          }
        })
        .catch((err)=>{console.log(err);})
      },
      getHistory(){
        this.$http.get(`/api/v1/estimations-supplier/history/${this.form_code}`)
        .then((resp)=>{
          this.$set(this , 'historyChange' , resp.data.data)
        })
        .catch((err)=>{console.log(err);})
      },
      validateForm(form){
        var valid = true;
        var error = [];
        if(typeof form.price_per_item == 'string')
          form.price_per_item = parseFloat(form.price_per_item.split(',').join(''))

        if(form.estimations_id == '' || form.estimations_id == null){//Sparepart [Required]
          valid = false;
          error.push('Sparepart wajib diisi');
        }

        if(this.universal.supplier_id == '' || this.universal.supplier_id == null){//Supplier [Required]
          valid = false;
          error.push('Supplier wajib diisi');
        }

        if(form.price_per_item == '' || form.price_per_item == null){//Harga Satuan [Required]
          valid = false;
          error.push('Harga Satuan wajib diisi');
        } else if (isNaN(form.price_per_item)) {
          valid = false;
          error.push('Harga Satuan harus berbentuk nomor');
        }

        if(form.inden == '' || form.inden == null){//Harga Satuan [Required]
          valid = false;
          error.push('Inden wajib diisi');
        } else if (isNaN(form.inden)) {
          valid = false;
          error.push('Inden harus berbentuk nomor');
        }

        if(typeof form.supplier_discount != 'number'){//Harga Satuan [Required]
          valid = false;
          error.push('Diskon Supplier wajib diisi');
        }

        // if(form.inclusivePPN =|| form.supplier_discount == null){//Harga Satuan [Required]
        //   valid = false;
        //   error.push('Diskon Supplier wajib diisi');
        // }

        if(!form.inclusivePPN && !form.exclusivePPN && !form.without_ppn) {
          valid = false;
          error.push('Settingan PPN Wajib Diisi');
        }

        if(form.supplier_pricelist == '' || form.supplier_pricelist == null){//Harga Satuan [Required]
          valid = false;
          error.push('Pricelist Supplier wajib diisi');
        }

        if(!valid) this.$store.dispatch('triggerAlert', [false, error]);
        else return valid;
      },
      async submitForm(form){
        form = JSON.parse(JSON.stringify(form))
        let vm = this;
        if(vm.validateForm(form)){
          
          form.supplier_id = this.universal.supplier_id
          // form.supplier_discount = form.supplier_discount

          //Convert from string to float
          // form.price_per_item = parseFloat(this.form.price_per_item)
          form.inden = parseInt(form.inden)


          if (form.inclusivePPN) {
            form.ppn_included = true
          }
          else if (form.exclusivePPN) {
            form.ppn_included = false
          }

          delete form.inclusivePPN
          delete form.exclusivePPN
           // form.markup = parseFloat(form.markup)
          delete form.total

          form.supplier_pricelist = form.supplier_pricelist.toString()
          form.supplier_discount = form.supplier_discount.toString()

          

          this.$http.post(`/api/v1/estimations-supplier/`, form)
          .then((resp)=>{
            // alert(`Partshop ${vm.form.name} has been created`);
            this.$store.dispatch('triggerAlert', [true, [`Estimasi supplier telah berhasil ditambahkan`]]);
            // this.$emit('updateTable');
            // this.$emit('closeModal');
            this.getSparepartEstimations()
            let formModel = JSON.parse(JSON.stringify(this.formModel))
            formModel.estimations_id = form.estimations_id
            this.$set(this.formList , form.estimations_id , formModel)
            
          })
          .catch((err)=>{
            console.log(err);
            this.$store.dispatch('triggerAlert', [false, ['An Error has occured']]);
          })
        }
      }
    }
  }
</script>

<style scoped>
  .wo-stats th {
    font-size:16px;
  }
  .wo-stats td {
    padding-left:10px;
  }
  
  .estimation-sparepart-table thead tr th{
    text-align: center;
  }

  .estimation-sparepart-table tbody tr td{
    text-align: center;
    vertical-align: middle;
  }
  
  .clickAble:hover{
    cursor: pointer;
  }

  .bg-green {
    background-color : #33ff33 !important;
  }

  .form-check-inline {
    margin-right: 0;
  }
</style>